// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6595":"css/app.6755","9844":"css/admin-app.6755"}[chunkId] + ".css";
};